import React, {useEffect, useState} from 'react'
import Encabezado from './Components/Encabezado'
import DatosCliente from './Components/GeneracionFactura/DatosCliente'
import DatosProducto from './Components/GeneracionFactura/DatosProducto'
import Footer from './Components/GeneracionFactura/Footer'
import ModalsGeneracionFactura from './Components/GeneracionFactura/Modals/ModalsGeneracionFactura'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../reducers'
import {bindActionCreators} from 'redux'
import {actionFacturacionEmision, actionsLogin} from '../../actions/action-creators'
import {LoaderRedux} from '../../components/LoaderRedux'
import TablaBienesServiciosCF from './Components/GeneracionFactura/TablaBienesServiciosCF'
import OtrosDocsAsociados from './Components/GeneracionFactura/OtrosDocAsociados'
import { BannerElegirSucursal } from '../../components/Banner/BannerElegirSucursal'
import DocumentosReceptor from '../../components/DocumentoReceptor/DocumentosReceptor'
import { setActiveModuleDoc } from '../../actions/documentos/documentos.actions'
import FormaPago from '../OtrosDocumentos/Components/FormaPago'
import ObservacionesDocumento from './Components/GeneracionFactura/ObservacionesDocumento'
import DescuentoGlobalFactura from './Components/GeneracionFactura/DescuentoGlobalFactura'
import { validateHorarioSucursal, validateUsoModulo } from '../../actions/general.actions'

const GeneracionFactura = () => {
  const loader = useSelector((state: State) => state.general.loader)
  const {calculosArrayProductos} = useSelector((state: State) => state.facturacion)
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionFacturacionEmision, dispatch)
  const {suscripcionGetFacturasDisponibles} = bindActionCreators(actionsLogin, dispatch)
  const [loader2, setLoader2] = useState(false)

  useEffect(() => {
    dispatch(validateUsoModulo())
    dispatch(validateHorarioSucursal())
    dispatch(setActiveModuleDoc({idDoc: '01', title: 'Factura'}));
    getSucursales()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSucursales = async () => {
    suscripcionGetFacturasDisponibles()
    await actions.facturacionPostSucursales('01')
    setLoader2(false)
  }

  return (
    <>
      {!loader && loader2 && <LoaderRedux />}
      <ModalsGeneracionFactura />
      <Encabezado url='/home' />
      <BannerElegirSucursal />
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout'>
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='dos-columnas-resp'>
            <DatosCliente />
            <DatosProducto />
          </div>
        </div>
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='card'>
            <div className='w-layout-vflex card-content'>
              <TablaBienesServiciosCF />
            </div>
          </div>
        </div>
        <DescuentoGlobalFactura />
        <FormaPago totalAPagar={calculosArrayProductos.totalPagar}/>
        <ObservacionesDocumento />
        <OtrosDocsAsociados />
        <DocumentosReceptor/>
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='card'>
            <div className='w-layout-vflex card-content'>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default GeneracionFactura
